/* /pages/albimo2026 — kategori bazlı "hub" (canlı sürüm, ortak kategori düzeni, 2026-10-05 akşam).
   Kategoriler (başlık + ikon) Liquid'den #ax-data.cats ile gelir = Specialpriser'deki başlıklar; ürünün kategorisi satırın 8. alanıdır (line-cat-key).
   Ürün verisi Liquid'in bastığı #ax-data JSON'undan gelir (her sayfa açılışında koleksiyondan okunur);
   kartların gruplanması (kategori + seri -> tek kart, varyant pill'leri) burada yapılır.
   Kaynak: Line2026/Store-Tech/theme_live_pages/assets/line-live-albimo-kat.js */
(function(){
  var root=document.getElementById('ax'); if(!root) return;
  var D=JSON.parse(document.getElementById('ax-data').textContent);
  var P=(D.p||[]).filter(Boolean);            // [handle,title,type,serie,price,compareAt,img,kategori]
  var CATS=D.cats||[];                        // [{k,t,svg}] — menü sırası; yalnızca ürünü olan kategori gösterilir
  var PAGES=D.pages||1, SID=D.sid;

  // ---- gruplama kuralları ----
  var ORDER=['AVVA','BARCELONA','PANDA','ARONYA','SAVANA','DORA','BAHA','CHELSEA','LARGO','META','TESLA','HAVANA','OPERA','MAGNUM',
    'ALANYA','JAWA','NORA','VILLA','LORA','MERLIN','OPTIMUM','SANTO','RUBATO','MADRID','COMO','FLAMINGO','BODRUM','HELYUM','LILA',
    'MARION','ORION','PIANO','QUATRO','ROY','TOKYO','VERONA','WOW','OLIMPOS','STOL'];
  var TYPE_ORDER=['soffgrupp','vardagsrumsset','sovrumsset','hörnsoffa','soffbord','sidobord','tv+soffbord','tv-bänk','soffa','fåtölj',
    'matgrupp','matbord','stolar','skänk','säng','sängbord','sminkbord','garderob'];
  var LABELS={'Vardagsrumsset':'Hela setet','Sovrumsset':'Hela setet','Stolar':'Stol','TV-bänk':'TV-bänk','Skänk':'Skänk m. spegel'};

  function typeRank(ty){ var t=ty.toLowerCase(); if(t==='skåp') t='tv-bänk'; var i=TYPE_ORDER.indexOf(t); return i<0?TYPE_ORDER.length:i; }
  function splitTitle(title){ var m=/^([A-ZÅÄÖ]+)(?:-([A-Z]))?\s+(.*)$/.exec(title); return m?[m[1],m[2]||null,m[3]]:[title,null,title]; }
  function shortLabel(ty,serie,rest){
    var x;
    if(serie==='stol') return rest.replace(/^Stol\s*/,'')||'Stol';
    if(ty==='Soffgrupp'){ x=/\d\+\d\+\d/.exec(rest); return x?x[0]:'Set'; }
    if(ty==='Hörnsoffa') return rest.indexOf('Relax')>-1?'Relax hörn':(rest.indexOf('Balkong')>-1?'Schäslong':'Hörn');
    if(ty==='Soffa'){ x=/(\d)-Sits/.exec(rest); return x?x[1]+'-sits':'Soffa'; }
    if(ty==='Matgrupp'){ x=/Rund.*?med (\d) ([\p{L}\p{N}_]+)/u.exec(rest); return x?'Rund + '+x[1]+' '+x[2]:'Bord + 6 stolar'; }
    return LABELS[ty]||ty;
  }
  function cmp(a,b){ return a<b?-1:a>b?1:0; }
  function build(list){
    var groups={}, keys=[];
    list.forEach(function(p){
      if(!(p[4]>0)||!p[3]) return;
      var st=splitTitle(p[1]);
      var r=p[7]||'ovrigt', chair=p[3]==='stol';
      var rund=!chair&&(/\bRun[dt]\b/.test(p[1])||/\bElkamin\b/i.test(p[1]));   // Rund masalar + Piallo med/utan Elkamin: her ürün AYRI kart   // 2026-10-08 Kenan: 90'lık yuvarlak masa + sandalye kombinasyonları ayrı kart
      var name=chair?st[0].toUpperCase()+' Stol':(rund?(p[1].toUpperCase().indexOf(p[3].toUpperCase().split('-')[0])===0?p[1]:p[3].toUpperCase().replace(/-/g,' ')+' '+p[1]):p[3].toUpperCase().replace(/-/g,' ')+(st[1]?'-'+st[1]:''));   // 2026-10-12 Kenan: A/B/C/D harfleri AYRI kart (PANDA-A, PANDA-B…)
      var k=r+'|'+name;
      if(!groups[k]){ groups[k]={r:r,name:name,chair:chair,ps:[]}; keys.push(k); }
      groups[k].ps.push({h:p[0],title:p[1],ty:p[2],serie:p[3],pr:p[4],ca:p[5],img:p[6],L:st[1],rest:st[2],rank:typeRank(p[2])});
    });
    var cards=keys.map(function(k){
      var g=groups[k], r=g.r;
      g.ps.sort(function(a,b){ return a.rank-b.rank||cmp(a.L||'',b.L||'')||b.pr-a.pr||cmp(a.title,b.title); });
      var letters={}; g.ps.forEach(function(p){ letters[p.L===null?'':p.L]=1; });
      var multi=Object.keys(letters).length>1, types=[];
      var vs=g.ps.map(function(p){
        var lab=shortLabel(p.ty,p.serie,p.rest);
        if(/med Elkamin/i.test(p.rest)) lab='Med elkamin'; else if(/utan Elkamin/i.test(p.rest)) lab='Utan elkamin';   // 2026-10-08 Piallo: elkamin ayrı ürün
        if(!g.chair&&multi&&p.L) lab=p.L+' '+lab;
        else if(g.chair&&p.L) lab=(lab!=='Stol')?p.L+' '+lab:p.L;
        if(types.indexOf(p.ty)<0) types.push(p.ty);
        return [p.h,lab,p.rest,p.pr,p.ca>p.pr?p.ca:0,p.img];
      });
      return {r:r,n:g.name,t:!g.chair?types.slice(0,3).join(' · '):vs.length+' varianter',v:vs};
    });
    var ridx={}; CATS.forEach(function(x,i){ ridx[x.k]=i; });
    cards.forEach(function(c){ if(!(c.r in ridx)) c.r=CATS.length?CATS[CATS.length-1].k:c.r; });
    function ord(c){ var i=ORDER.indexOf(c.n.split(/[\s-]+/)[0]); return i<0?99:i; }
    cards.sort(function(a,b){ return ridx[a.r]-ridx[b.r]||ord(a)-ord(b)||cmp(a.n,b.n); });
    var rooms=[];
    CATS.forEach(function(x){
      var rc=cards.filter(function(c){ return c.r===x.k; }); if(!rc.length) return;
      var min=Infinity, cnt=0;
      rc.forEach(function(c){ c.v.forEach(function(v){ cnt++; if(v[3]<min) min=v[3]; }); });
      rooms.push({k:x.k,slug:x.k,tab:x.t,name:x.t,g:x.g||'',svg:x.svg,min:min,n:rc.length,cnt:cnt});
    });
    return {rooms:rooms,cards:cards};
  }

  // ---- arayüz ----
  var R=[], C=[];
  var PR=[[0,1e9,'Alla priser'],[0,9999,'Under 10 000'],[10000,19999,'10–20 000'],[20000,29999,'20–30 000'],[30000,1e9,'Över 30 000']];
  var st={room:null,pr:0,sort:'lo',n:12}; // varsayılan: lägsta pris först (Kenan 2026-10-13)
  var main=root.querySelector('.main'), tabs=root.querySelector('.tabs'), filt=root.querySelector('.filters'), bar=root.querySelector('.bar'), rgrid=root.querySelector('.bx-tgroups');
  var hdr=document.querySelector('.section-header');
  // Grup düzeni (2026-10-12, Kenan): kaydırma yok — ekrana sığan tek satır (mobil 2 / tablet 3 / masaüstü 4), altında "Visa alla",
  // grup görünümünde tüm ürünler + en altta "← Tillbaka till <sayfa>".
  var mqS=window.matchMedia('(max-width:700px)'), mqM=window.matchMedia('(max-width:1024px)');
  function ncols(){ return mqS.matches?2:(mqM.matches?3:4); }
  var PAGE=(document.title||'').split(/\s[–|-]\s/)[0].trim()||'sidan';
  function fmt(n){return Math.round(n).toLocaleString('sv-SE').replace(/\s/g,' ')+':-';}
  function im(u,w){return u?u+(u.indexOf('?')>-1?'&':'?')+'width='+w:'';}
  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function vs(c){var a=PR[st.pr];return c.v.filter(function(v){return v[3]>=a[0]&&v[3]<=a[1];});}
  function room(k){for(var i=0;i<R.length;i++) if(R[i].k===k) return R[i];}
  function card(ci,list){
    var c=C[ci], v=list[0];
    var pills=list.length>1?'<div class="pills">'+list.map(function(x,j){return '<button class="pl'+(j?'':' on')+'" data-j="'+j+'">'+esc(x[1])+'</button>';}).join('')+'</div>':'';
    var el='<div class="card" data-c="'+ci+'">'
      +'<a class="fig" href="/products/'+v[0]+'"><img src="'+im(v[5],520)+'" alt="'+esc(c.n+' '+v[2])+'" loading="lazy" width="520" height="520">'
      +'<span class="badge"'+(v[4]?'':' hidden')+'>'+(v[4]?'−'+Math.round((1-v[3]/v[4])*100)+'%':'')+'</span>'
      +(list.length>1?'<span class="cnt">'+list.length+' val</span>':'')+'</a>'
      +'<div class="body"><a class="ct" href="/products/'+v[0]+'">'+esc(c.n)+'</a><div class="cs">'+esc(v[2])+'</div>'+pills
      +'<div class="crow"><span class="pp"><s'+(v[4]?'':' hidden')+'>'+(v[4]?fmt(v[4]):'')+'</s><b>'+fmt(v[3])+'</b></span><a class="cta" href="/products/'+v[0]+'">Se mer →</a></div></div></div>';
    return el;
  }
  function cards(k){
    var out=[];
    C.forEach(function(c,i){ if(c.r!==k) return; var l=vs(c); if(l.length) out.push([i,l]); });
    if(st.sort!=='rek') out.sort(function(a,b){
      var pa=Math.min.apply(null,a[1].map(function(v){return v[3];})), pb=Math.min.apply(null,b[1].map(function(v){return v[3];}));
      return st.sort==='lo'?pa-pb:pb-pa; });
    if(st.sort==='lo') out.forEach(function(x){x[1]=x[1].slice().sort(function(a,b){return a[3]-b[3];});});
    return out;
  }
  function renderRooms(){
    if(!rgrid) return;
    // kutular grup grup (Vardagsrum / Matsal / Sovrum …): her grubun kendi başlığı + kaydırmalı satırı
    var groups=[], by={};
    R.forEach(function(r){ if(!by[r.g]){ by[r.g]=[]; groups.push(r.g); } by[r.g].push(r); });
    rgrid.innerHTML=groups.map(function(g){
      return '<div class="bx-tgrp">'+(g?'<p class="bx-tgroup">'+esc(g)+'</p>':'')
        +'<div class="bx-trow"><button type="button" class="bx-tarr l" aria-label="Föregående" hidden>‹</button><div class="bx-tscroll">'
        +by[g].map(function(r){
          return '<a class="bx-tile'+(st.room===r.k?' on':'')+'" href="#'+r.slug+'" data-room="'+r.k+'">'+r.svg
            +'<span class="bx-tl">'+esc(r.tab)+'</span><span class="bx-tc">'+r.cnt+' st</span></a>';
        }).join('')
        +'</div><button type="button" class="bx-tarr r" aria-label="Nästa" hidden>›</button></div></div>';
    }).join('');
    if(window.lineTilesInit) window.lineTilesInit();
  }
  function markTile(){ if(!rgrid) return; [].forEach.call(rgrid.querySelectorAll('.bx-tile'),function(a){ a.classList.toggle('on',a.getAttribute('data-room')===st.room); }); }
  function renderTabs(){
    tabs.innerHTML='<button class="tab'+(st.room?'':' on')+'" data-room="">Alla</button>'+R.map(function(r){return '<button class="tab'+(st.room===r.k?' on':'')+'" data-room="'+r.k+'">'+esc(r.tab)+'</button>';}).join('');
    var on=tabs.querySelector('.on'); if(on) tabs.scrollTo({left:on.offsetLeft-tabs.clientWidth/2+on.offsetWidth/2,behavior:'smooth'});
    filt.hidden=!st.room;
    if(st.room) filt.innerHTML=PR.map(function(p,i){return '<button class="chip'+(st.pr===i?' on':'')+'" data-pr="'+i+'">'+p[2]+'</button>';}).join('')
      +'<select class="sort" aria-label="Sortera"><option value="rek">Rekommenderat</option><option value="lo">Lägsta pris</option><option value="hi">Högsta pris</option></select>';
    var s=filt.querySelector('.sort'); if(s) s.value=st.sort;
  }
  function render(){
    renderTabs(); markTile();
    var h='';
    if(!st.room){
      R.forEach(function(r){
        var l=cards(r.k); if(!l.length) return;
        var nc=ncols();
        h+='<div class="rowhead" id="row-'+r.slug+'"><div class="shead"><span class="sico" aria-hidden="true">'+(r.svg||'')+'</span><div><p class="slbl">'+(r.g?esc(r.g)+' · ':'')+l.length+' serier · från '+fmt(r.min)+'</p><h2 class="h2">'+esc(r.name)+'</h2></div></div></div>'
          +'<div class="grid rowgrid">'+l.slice(0,nc).map(function(x){return card(x[0],x[1]);}).join('')+'</div>'
          +(l.length>nc?'<div class="visa-more"><button class="visa-btn" data-room="'+r.k+'">Visa alla ('+l.length+' st) →</button></div>':'');
      });
    } else {
      var r=room(st.room), l=cards(st.room);
      h='<div class="roomhead"><div class="shead"><span class="sico" aria-hidden="true">'+(r.svg||'')+'</span><div><p class="slbl">'+(r.g?esc(r.g)+' · ':'')+l.length+' serier · från '+fmt(r.min)+'</p><h2 class="h2">'+esc(r.name)+'</h2></div></div></div>';
      h+=l.length?'<div class="grid">'+l.map(function(x){return card(x[0],x[1]);}).join('')+'</div>':'<p class="empty">Inga produkter i den här prisklassen.</p>';
      h+='<div class="visa-back"><button class="visa-btn visa-ret" data-back="'+r.slug+'">← Tillbaka till '+esc(PAGE)+'</button></div>';
    }
    main.innerHTML=h;
    [].forEach.call(main.querySelectorAll('.card'),function(el){ var c=C[+el.getAttribute('data-c')]; el._l=vs(c); if(st.sort==='lo') el._l.sort(function(a,b){return a[3]-b[3];}); });
  }
  function load(){
    var b=build(P); R=b.rooms; C=b.cards;
    if(st.room&&!room(st.room)) st.room=null;
    renderRooms(); render();
    root._ax={rooms:R,cards:C,products:P.length};   // doğrulama/inceleme için
  }
  function top(){ if(!hdr) return 0; var r=hdr.getBoundingClientRect(); return Math.max(0,Math.round(r.bottom)); }
  function sync(){ root.style.setProperty('--top',top()+'px'); }
  // tema html{scroll-behavior:smooth}: görünüm değişirken anlık kaydır, görseller yerleşince tekrar düzelt (yoksa sayfa footer'da kalıyordu)
  function toMain(inst){
    // .bar yapışkan (sticky) → hedef olarak kullanılamaz; ürün alanının (.main) başı - üst menü - çubuk yüksekliği
    function y(){ return Math.max(0,Math.round(main.getBoundingClientRect().top+window.pageYOffset-top()-(bar?bar.offsetHeight:0)-8)); }
    var t=y(); if(!(window.pageYOffset>t||st.room)) return;
    window.scrollTo({top:t,behavior:inst?'instant':'smooth'});
    if(inst) [120,400,900].forEach(function(ms){ setTimeout(function(){ if(Math.abs(window.pageYOffset-t)>4) return; t=y(); window.scrollTo({top:t,behavior:'instant'}); },ms); });
  }
  function jumpTo(el){
    if(!el) return;
    function y(){ return Math.max(0,Math.round(el.getBoundingClientRect().top+window.pageYOffset-top()-(bar?bar.offsetHeight:0)-12)); }
    var t=y(); window.scrollTo({top:t,behavior:'instant'});
    [120,400,900].forEach(function(ms){ setTimeout(function(){ if(Math.abs(window.pageYOffset-t)>4) return; t=y(); window.scrollTo({top:t,behavior:'instant'}); },ms); });
  }
  function go(k){
    st.room=k||null; st.n=12; st.pr=0; st.sort='lo';
    var r=k&&room(k); if(r) history.pushState(null,'','#'+r.slug); else history.replaceState(null,'',location.pathname+location.search);
    render(); toMain(!!k);
  }
  root.addEventListener('click',function(e){
    var t=e.target.closest('[data-room],[data-pr],[data-j],[data-back],.morebtn,.arr'); if(!t) return;
    if(t.hasAttribute('data-back')){ e.preventDefault(); var sl=t.getAttribute('data-back'); st.room=null; st.n=12; st.pr=0; st.sort='lo'; history.replaceState(null,'',location.pathname+location.search); render(); jumpTo(document.getElementById('row-'+sl)); return; }
    if(t.hasAttribute('data-room')){ e.preventDefault(); go(t.getAttribute('data-room')); return; }
    if(t.hasAttribute('data-pr')){ st.pr=+t.getAttribute('data-pr'); st.n=12; render(); return; }
    if(t.classList.contains('morebtn')){ st.n+=12; render(); return; }
    if(t.classList.contains('arr')){ var tr=t.parentNode.querySelector('.track'); tr.scrollBy({left:(t.classList.contains('l')?-1:1)*tr.clientWidth*.8,behavior:'smooth'}); return; }
    var el=t.closest('.card'), v=el._l[+t.getAttribute('data-j')];
    [].forEach.call(el.querySelectorAll('.pl'),function(b){b.classList.toggle('on',b===t);});
    [].forEach.call(el.querySelectorAll('a'),function(a){a.href='/products/'+v[0];});
    var img=el.querySelector('img'); img.src=im(v[5],520);
    el.querySelector('.cs').textContent=v[2];
    var b=el.querySelector('.badge'); b.hidden=!v[4]; b.textContent=v[4]?'−'+Math.round((1-v[3]/v[4])*100)+'%':'';
    var s=el.querySelector('.pp s'); s.hidden=!v[4]; s.textContent=v[4]?fmt(v[4]):'';
    el.querySelector('.pp b').textContent=fmt(v[3]);
  });
  root.addEventListener('change',function(e){ if(e.target.classList.contains('sort')){ st.sort=e.target.value; st.n=12; render(); } });
  window.addEventListener('scroll',sync,{passive:true}); window.addEventListener('resize',sync); sync();
  [mqS,mqM].forEach(function(m){ var f=function(){ if(!st.room) render(); }; if(m.addEventListener) m.addEventListener('change',f); else if(m.addListener) m.addListener(f); });
  window.addEventListener('popstate',function(){ var hs=location.hash.slice(1), k=null; R.forEach(function(r){ if(r.slug===hs) k=r.k; }); if(k!==st.room){ st.room=k; render(); } });

  var hash=location.hash.slice(1);
  function pickHash(){ R.forEach(function(r){ if(r.slug===hash) st.room=r.k; }); }
  load(); pickHash(); if(st.room){ render(); toMain(true); setTimeout(function(){ toMain(true); },350); }

  // Liquid tek seferde en fazla 250 ürün basar: kalan sayfaları section rendering ile çek, veriye ekle, yeniden çiz.
  (function more(n){
    if(n>PAGES||!SID) return;
    var u=new URL(location.href); u.hash=''; u.searchParams.set('page',n); u.searchParams.set('section_id',SID);
    fetch(u.toString()).then(function(r){ return r.ok?r.text():Promise.reject(); }).then(function(html){
      var el=new DOMParser().parseFromString(html,'text/html').getElementById('ax-data'); if(!el) return;
      var seen={}; P.forEach(function(p){ seen[p[0]]=1; });
      (JSON.parse(el.textContent).p||[]).forEach(function(p){ if(p&&!seen[p[0]]) P.push(p); });
      var had=st.room; load(); if(!had&&hash){ pickHash(); if(st.room) render(); }
      more(n+1);
    }).catch(function(){});
  })(2);
})();
